import {Accordion} from 'react-bootstrap';


function Education() {

  return (
    <Accordion>
        <Accordion.Item eventKey="0">
            <Accordion.Header>
                <p>
                <h4>STI College Bacoor | Bacoor City, Cavite PH</h4>
                <b>Bachelor's/College Degree in Computer Science/Information Technology</b> 2004
                </p>
            </Accordion.Header>
            <Accordion.Body>
                <p>
                    <ul style={{ listStyleType: "none" }}>
                        <li>Major B.S. Computer Science</li>
                        <li>Grade Incomplete</li>
                    </ul>
                </p>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
            <Accordion.Header>
                <p>
                <h4>STI College Bacoor | Bacoor City, Cavite PH</h4>
                <b>Vocational Diploma / Short Course Certificate in Computer Science/Information Technology</b> 2003
                </p>
            </Accordion.Header>
            <Accordion.Body>
                <p>
                    <ul style={{ listStyleType: "none" }}>
                        <li>Major Associate in Computer Technology</li>
                        <li>CGPA 85.0 / 100.0</li>
                    </ul>
                </p>
            </Accordion.Body>
        </Accordion.Item>
    </Accordion>
  );
}

export default Education;